// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__U91TC","bigColWidth":"Table_bigColWidth__1LDQu","biggerColWidth":"Table_biggerColWidth__2KWSY","row":"Table_row__2dTCh","col":"Table_col__3u1XO"};